ApiAjax = require 'network/api-ajax'
Confirm = require 'views/lib/confirm'
Dates = require 'lib/dates'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
l = require 'lib/localize'

module.exports = class LoginView extends View
  className: 'member-login'

  events:
    'click .js-primary': 'setPrimary'
    'click .js-remove': 'confirmDeleteLogin'

  initialize: ->
    @listenTo @model, 'change', @render

  render: ->
    data = @model.toJSON()
    data.dateAdded = Util.idToDate(data.id).toISOString()

    @$el.html(
      templates.fill(
        'member_login',
        data
      )
    )

    Dates.update(@el)

    @

  setPrimary: (e) ->
    ApiAjax
      url: "/1/members/me/logins/#{ @model.id }/primary"
      type: 'put'
      success: (data) =>
        @model.set('primary', true)

  confirmDeleteLogin: (e) ->
    Util.stop(e)

    # Check if we can remove this login. If not, show the set password dialog
    # instead.
    if @model.hasConflict()
      @trigger('requestSetPassword')
      return

    Confirm.toggle 'delete credential', @popover
      html: l('confirm.delete credential.text', { email: @model.get('email') })
      confirmBtnClass: 'negate'
      fxConfirm: => @deleteLogin()

   popover: (opts) ->
     _.extend { elem: @$('.js-remove') }, opts

  deleteLogin: ->
    ApiAjax
      url: "/1/members/me/logins/#{ @model.id }"
      type: 'delete'
      success: (data) =>
        @model.trigger('destroy', @model, @model.collection)



// WEBPACK FOOTER //
// ./app/scripts/views/member/login-view.coffee